import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('c3i_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      if (token) {
        try {
          const response = await axios.get(`${API}/auth/me?Authorization=Bearer ${token}`);
          setUser(response.data);
        } catch (error) {
          console.error('Auth init failed:', error);
          localStorage.removeItem('c3i_token');
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };
    initAuth();
  }, [token]);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    const { access_token, user: userData } = response.data;
    localStorage.setItem('c3i_token', access_token);
    setToken(access_token);
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('c3i_token');
    setToken(null);
    setUser(null);
  };

  const getAuthHeader = () => {
    return token ? `Bearer ${token}` : '';
  };

  const isAmministratore = () => user?.ruolo_con_accesso === 'AMMINISTRATORE';
  const isAdminOrdine = () => user?.ruolo_con_accesso === 'ADMIN_ORDINE';
  const isConsigliere = () => user?.ruolo_con_accesso === 'CONSIGLIERE_C3I';
  const isCoordinatoreGTL = () => user?.ruolo_con_accesso === 'COORDINATORE_GTL';
  const canEdit = () => isAmministratore() || isAdminOrdine();

  return (
    <AuthContext.Provider value={{ 
      user, 
      token,
      loading, 
      login, 
      logout, 
      getAuthHeader,
      isAmministratore,
      isAdminOrdine,
      isConsigliere,
      isCoordinatoreGTL,
      canEdit,
      // Legacy aliases for compatibility
      isSegretario: isAmministratore,
      isOsservatore: isConsigliere
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
